import "./BookAppointment.module.css";
import Header from "@/reusable_sections/Header";
import HeroPrincipal from "./sections/HeroPrincipal";
import ClinicCards from "./sections/ClinicCards";
import MemberRegistrationForm from "./sections/MemberRegistrationForm";
import Maps from "./sections/Maps";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function BookAppointmentPage() {
  return <div>
      <Header />
      <HeroPrincipal />
      <ClinicCards />
      <MemberRegistrationForm />
      <Maps />
      <Faq />
      <Footer />
    </div>;
}